module.exports = __webpack_public_path__ + "static/media/signage-indoor-img61.7a5e1d65.jpg";